import * as React from "react";
import { Hint, Suit } from "../common";

export enum Size {
  Large = "large",
  Small = "small"
}

interface Props {
  size: Size;
  number: number;
  suit: Suit;
  hint: Hint;
  canHint: boolean;
}

export class Card extends React.Component<Props, {}> {
  public static defaultProps = {
    hint: Hint.None,
    canHint: false
  };

  render() {
    const { size, number, suit, hint, canHint } = this.props;

    const extraClasses: string[] = [size, suit];

    let hintElement;
    if (hint === Hint.None) {
      extraClasses.push("nohint");
    } else {
      let hintText = hint.toString()[0].toUpperCase();
      hintElement = <div className={"hint " + hint}>{hintText}</div>;
    }

    let hintLink;
    if (this.props.canHint) {
      hintLink = (
        <div className="hintlink">
          <a>Hint this card</a>
        </div>
      );
    }

    return (
      <div className="cardContainer">
        {hintElement}
        <div className={"card " + extraClasses.join(" ")}>
          <div>{number}</div>
          <div className="rotated">{number}</div>
        </div>
        {hintLink}
      </div>
    );
  }
}
